import { getMessage } from 'common/helpers/miscHelper';

const SideCartMessage = (props) => {
  const { settings } = props;
  return (
    <div
      className="c7-cart__carrot"
      dangerouslySetInnerHTML={{
        __html: getMessage('Side Cart Message', settings)
      }}
    />
  );
};

export default SideCartMessage;
